import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../utils/api';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);
  
  useEffect(() => {
    // If user data passed from AuthCallback, skip auth check
    if (location.state?.user) {
      setIsAuthenticated(true);
      setUser(location.state.user);
      return;
    }
    
    const checkAuth = async () => {
      try {
        const response = await api.get('/api/auth/me');
        
        if (response.status === 200) {
          setIsAuthenticated(true);
          setUser(response.data);
          // Update cached user data
          localStorage.setItem('user_data', JSON.stringify(response.data));
        } else {
          // Clear localStorage on auth failure
          localStorage.removeItem('session_token');
          localStorage.removeItem('user_data');
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        // Clear localStorage on auth failure
        localStorage.removeItem('session_token');
        localStorage.removeItem('user_data');
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, [location.state]);
  
  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-foreground">Loading...</p>
        </div>
      </div>
    );
  }
  
  // Not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Authenticated - render children with user context
  return React.cloneElement(children, { user });
};

export default ProtectedRoute;